module.exports = __webpack_public_path__ + "media/images/placeholder-teams-1c218158.png";